<template>
  <div>
    <title>铺券汇总</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <CompanyTab :active="currentTit"></CompanyTab>
      <!--E 头部tab-->

      <!--S 检索-->
      <el-form :model="searchGLForm" inline class="searchForm">
        <!--注：门店、业务员、会员视不同身份进入展示不用检索-->
        <!-- <el-form-item label="门店">
          <el-select v-model="searchGLForm.flowcode" filterable placeholder="请选择或输入" clearable>
            <el-option
              v-for="(item,index) in storeList"
              :key="index"
              :label="item.label"
              :value="item.value"
              :title="item.label">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="业务员" v-if="userInfoMd.objtype==0 || (userInfoMd.objtype!=0&&userInfoMd.isopenfinancial)">
          <FlowSelectPage eleType='铺券' :type="6" @flowObtain="transferReceive"></FlowSelectPage>
        </el-form-item>
        <el-form-item label="会员分销商" v-else>
          <MemberChoseSelecter eleType="铺券"  v-model="searchGLForm.membercode" @setMember="setMemberInfo" placeholder="请选择会员分销商"></MemberChoseSelecter>
        </el-form-item>
        <el-form-item label="序列号段" class="serialInput">
          <el-input v-model="searchGLForm.sserial" clearable placeholder="起始序列号" maxlength="16"></el-input>
          <small>~</small>
          <el-input v-model="searchGLForm.eserial" clearable placeholder="结束序列号" maxlength="16"></el-input> 
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querySubmit">查询</el-button>
          <el-button type="primary" plain v-show="!expoerHandle" @click="toPrinting(0,'列表')">检索导出</el-button>
          <el-button type="primary" plain v-show="!expoerHandle" @click="expoerHandle = true">勾选导出</el-button>
          <el-button type="danger" v-show="expoerHandle" icon="el-icon-close" round @click="confirmCancel()">取消</el-button>
          <el-button type="success" v-show="expoerHandle" icon="el-icon-check" round @click="toPrinting(1,'列表')">确定</el-button>
        </el-form-item>
        <el-form-item>
          <span class="breathTit iconbulb orangeColor">已回收券卡不计入总数</span>
        </el-form-item>
      </el-form>
      <!--E 检索-->
      <!--S 铺券列表-->
      <el-table ref="gsTable" class="comTable" border :data="cardShopData" :maxHeight="tableHeight" @selection-change="handleSelectionChange" v-loading="loading">
        <el-table-column v-if="expoerHandle" type="selection" width="80" fixed></el-table-column>
        <el-table-column type="index" label="序号" width="60" fixed></el-table-column>
        <!-- <el-table-column label="门店/业务员" sortable min-width="200" fixed>
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.flowname">{{scope.row.flowname}}</p>
          </template>
        </el-table-column> -->
        <el-table-column :label="(userInfoMd.objtype==0 || (userInfoMd.objtype!=0&&userInfoMd.isopenfinancial))?'业务员':'会员分销商'" sortable prop="person" min-width="200" fixed>
          <template slot-scope="scope">
            <p :title="scope.row.flowname" class="textFl pdr70">{{scope.row.flowname}}</p> 
            <!-- <small :title="scope.row.membertel">{{scope.row.membertel}}</small>  -->
          </template>
        </el-table-column>
        <el-table-column label="总数" prop="lnum" sortable min-width="120" align="center">
          <template slot-scope="scope">
            <span class="cityName iconhand cursorHand" :title="scope.row.lnum" @click="openGatherMore(scope.row,-1)" v-if="Number(scope.row.lnum)!=0">{{scope.row.lnum}}</span>
            <span :title="scope.row.lnum" v-else>{{scope.row.lnum}}</span>
          </template>
        </el-table-column>
        <el-table-column label="未激活" prop="wjh" sortable min-width="120" align="center">
          <template slot-scope="scope">
            <span class="cityName iconhand cursorHand" :title="scope.row.wjh" @click="openGatherMore(scope.row,0)" v-if="Number(scope.row.wjh)!=0">{{scope.row.wjh}}</span>
            <span :title="scope.row.wjh" v-else>{{scope.row.wjh}}</span>
          </template>
        </el-table-column>
        <el-table-column label="已激活" prop="yjh" sortable min-width="120" align="center">
          <template slot-scope="scope">
            <span class="cityName iconhand cursorHand" :title="scope.row.yjh" @click="openGatherMore(scope.row,1)" v-if="Number(scope.row.yjh)!=0">{{scope.row.yjh}}</span>
            <span :title="scope.row.yjh" v-else>{{scope.row.yjh}}</span>
          </template>
        </el-table-column>
        <el-table-column label="已作废" prop="yzf" sortable min-width="120" align="center">
          <template slot-scope="scope">
            <span class="cityName iconhand cursorHand" :title="scope.row.yzf" @click="openGatherMore(scope.row,2)" v-if="Number(scope.row.yzf)!=0">{{scope.row.yzf}}</span>
            <span :title="scope.row.yzf" v-else>{{scope.row.yzf}}</span>
          </template>
        </el-table-column>
        <el-table-column label="已回收" prop="yhs" sortable min-width="120" align="center">
          <template slot-scope="scope">
            <span :title="scope.row.yhs">{{scope.row.yhs}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--E 铺券列表-->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
    </section>

    <!--S 铺券列表详情-->
    <el-dialog :visible.sync="gatherMoreShow" :title="(rowInfo?rowInfo.flowname:'') + ' - 铺券详情'" class="comDlog gatherDetail" append-to-body :close-on-click-modal="false" :before-close="openGatherMore">
      <el-form :model="formInline" inline>
          <!-- <el-form-item label="业务员">
            <FlowSelectPage eleType='铺券' :type="6" @flowObtain="transferReceive" :flowcode="formInline.corderInfo?formInline.corderInfo.flowcode:''" v-if="gatherMoreShow"></FlowSelectPage>
          </el-form-item> -->
          <el-form-item label="会员分销商" v-if="userInfoMd.objtype==0 || (userInfoMd.objtype!=0&&userInfoMd.isopenfinancial)">
            <MemberChoseSelecter eleType="铺券" :dyflowcode="formInline.corderInfo?formInline.corderInfo.flowcode:''" v-model="formInline.membercode" :isMemberInfo="detailBindMemberInfo" @setMember="setMemberInfo" placeholder="请选择会员分销商" v-if="gatherMoreShow"></MemberChoseSelecter>
          </el-form-item>
          <el-form-item label="铺券时间">
            <!-- S 双日期选择器 -->
            <TwoDatePicker
              @twoDateObtain="shopDateReceive"
              :startvaldate="formInline.shopTime.length>0?formInline.shopTime[0]:''"
              :endvaldate="formInline.shopTime.length>0?formInline.shopTime[1]:''"
              key="out">
            </TwoDatePicker>
            <!-- E 双日期选择器 -->
          </el-form-item>
          <el-form-item label="销售状态" class="formTimeSlot">
            <el-select v-model="formInline.salestate" placeholder="请选择销售状态" clearable>
              <el-option label="未激活" :value="0"></el-option>
              <el-option label="已激活" :value="1"></el-option>
              <el-option label="已作废" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="detailQuerySubmit">查询</el-button>
              <el-button type="primary" plain v-show="!expoerHandledg" @click="toPrinting(0,'详情')">检索导出</el-button>
              <el-button type="primary" plain v-show="!expoerHandledg" @click="expoerHandledg = true">勾选导出</el-button>
              <el-button type="danger" v-show="expoerHandledg" icon="el-icon-close" round @click="confirmCancel()">取消</el-button>
              <el-button type="success" v-show="expoerHandledg" icon="el-icon-check" round @click="toPrinting(1,'详情')">确定</el-button>
          </el-form-item>
      </el-form>
      <el-table ref="gatherCardRef" :data="gatherCardData" border class="comTable" height="410" @selection-change="handleSelectionChangeDG" v-loading="detailLoading">
        <el-table-column v-if="expoerHandledg" type="selection"  width="80" fixed></el-table-column>
        <el-table-column type="index" label="序号" width="60" fixed></el-table-column>
        <!-- <el-table-column label="业务员" sortable min-width="150" v-if="userInfoMd.objtype==0 || (userInfoMd.objtype!=0&&userInfoMd.isopenfinancial)" fixed>
          <template slot-scope="scope">
            <p class="textFl pdr70" :title="scope.row.corderuname">{{scope.row.corderuname}}</p>
          </template>
        </el-table-column> -->
        <el-table-column label="会员分销商" sortable prop="nickname" min-width="200" v-if="userInfoMd.objtype==0 || (userInfoMd.objtype!=0&&userInfoMd.isopenfinancial)">
          <template slot-scope="scope">
            <p :title="scope.row.nickname" class="textFl pdr70">{{scope.row.nickname}}</p> 
            <!-- <small :title="scope.row.membertel">{{scope.row.membertel}}</small>  -->
          </template>
        </el-table-column>
        <el-table-column label="券卡编码" sortable prop="code" min-width="310">
          <template slot-scope="scope">
            <p :title="scope.row.code+'【'+scope.row.serial+'】'">{{scope.row.code}}【{{scope.row.serial}}】</p>
            <small>铺券时间：{{scope.row.submitdate}}</small>
          </template>
        </el-table-column>
        <el-table-column label="销售状态" sortable prop="salestate" min-width="220">
          <template slot-scope="scope">
            <p :title="scope.row.salestate" :class="[{'greyColor':scope.row.salestate==0},{'orangeColor':scope.row.salestate==1},{'redColor':scope.row.salestate==2}]">{{scope.row.salestateName}}</p>
            <small v-if="scope.row.salestate!=0">激活时间：{{scope.row.actdate!=undefined?scope.row.actdate:'--'}}</small>
          </template>
        </el-table-column>
        <el-table-column label="绑定商品" min-width="150">
          <template slot-scope="scope">
            <span class="iconhand cursorHand cityName" @click="getShowChoseGoods(scope.row.code)" v-if="scope.row.optgoodsuid">共{{scope.row.selzones}}个可选专区</span>
            <p class="textFl" :title="scope.row.defaultgoodsname" v-else>{{scope.row.defaultgoodsname}}</p>
          </template>
        </el-table-column>
        <el-table-column label="提货状态" min-width="120">
          <template slot-scope="scope">
            <p v-if="scope.row.salestate==0">--</p>
            <p v-else :class="[{'greenColor':scope.row.submitstate==1},{'orangeColor':scope.row.submitstate==2},{'blueColor':scope.row.submitstate==3}]">{{scope.row.submitstate | deliverystatusFilter}}</p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
      <Page :pageTotal="detailPagebBean.totalnum" :currentPage="detailCurrentPage" @nowPageParam="detailUpdatePage"></Page>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openGatherMore(0)">关闭</el-button>
      </span>
    </el-dialog>
    <!--E 铺券列表详情-->

    <!-- S 查看可选商品 -->
    <GoodsChoose eleType="铺券" :goodsChoseDialogVisible="goodsChoseDialogVisible" :isCardCode="cardCode" @closeGoodsPop="closeGoodsChoose"></GoodsChoose>
    <!-- E 查看可选商品 -->

  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
  name: 'CardGather',
  data () {
    return {
      currentTit:4,
      storeList: [
        { value: 0, label: "A门店" },
        { value: 1, label: "B门店" },
        { value: 2, label: "C门店" }
      ], //门店列表
      clerkList: [
        { value: 0, label: "A店员" },
        { value: 1, label: "B店员" },
        { value: 2, label: "C店员" }
      ], //店员列表
      searchGLForm:{
        flowcode:'',//门店
        corderInfo:'',//业务员信息
        sserial:'',//起始序列号
        eserial:'', //结束序列号
        membercode:'',//会员分销商
        shopTime: '', //铺券时间
        current:0,//当前检索时限,0：全部，1：本年度，2：本季度，3：本月 4：本周
      },
      timeLimit:['全部','本年度','本季度','本月','本周'],//检索时限
      cardShopData:[], // 外层列表数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      userInfoMd: {}, // 登录信息
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      loading: false, // 加载中弹窗显示和隐藏
      printingShow: true, // 防止多次点击导出按钮
      bindMemberInfo: null, // 选择的会员信息

      // 详情参数 ---------------------------------------- 详情参数
      gatherMoreShow:false,//铺券详细
      formInline:{
        corderInfo:'',//业务员信息
        membercode:'',//会员分销商
        shopTime: [], //铺券时间
        salestate:'',//销售状态
      },
      gatherCardData:[],
      goodsChoseDialogVisible: false, //可选商品弹框
      cardCode: '', // 查看商品的券卡编号
      detailPageSize: 30, // 每页展示的条数
      detailCurrentPage: 1, // 当前请求的页数
      detailPagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      multipleSelection: [], //已选中的行
      expoerHandle:false, // 勾选确定取消
      multipleSelectiondg: [], //已选中的行
      expoerHandledg:false, // 勾选确定取消
      detailLoading: false, // 加载中弹窗显示和隐藏
      detailBindMemberInfo: null, // 选择的会员信息
      rowInfo: '', // 查看的行信息
    }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    MemberChoseSelecter: resolve => require(["@/components/OrderFolder/StoreSale/MemberChoseSelecter.vue"], resolve),
    GoodsChoose: resolve =>require(["@/components/StatisticsFolder/GoodsChoose.vue"], resolve), // 专区商品信息组件
    TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
    FlowSelectPage: resolve =>
      require(["@/components/GoodsFolder/GoodsSingle/FlowSelectPage.vue"], resolve), // 获取流向组件
  },
  filters:{
    //销售状态过滤
    salestatusFilter(val){
      if(val==0){
        return '未激活'
      }else if(val==1){
        return '已激活'
      }else if(val==2){
        return '已作废'
      }
    },
    //提货状态过滤
    deliverystatusFilter(val){
      if(val==1){
        return '未提货'
      }else if(val==2){
        return '部分提货'
      }else if(val==3){
        return '已提货'
      }
    }
  },
  watch: {
  },
  methods: {
    // 接收传递的业务员的检索
    transferReceive(val){
      if(this.gatherMoreShow) {
        this.formInline.corderInfo = val;
      } else {
        this.searchGLForm.corderInfo = val;
      }
    }, 
    // 接收选择的会员信息
    setMemberInfo(val) {
      if(this.gatherMoreShow) {
        this.detailBindMemberInfo = val;
      } else {
        this.bindMemberInfo = val;
      }
    },
    //表格多选选中行复制
    handleSelectionChange(val) { 
      this.multipleSelection = val;
    },
    //表格多选选中行复制
    handleSelectionChangeDG(val) { 
      this.multipleSelectiondg = val;
    },
    //确定取消勾选导出
    confirmCancel(){
      this.expoerHandle = false;
      this.expoerHandledg = false;
      this.multipleSelection = [];
      this.$refs.gsTable.clearSelection(); // 清空选中列表数据
      this.multipleSelectiondg = [];
      if(this.$refs.gatherCardRef!=undefined) {
        this.$refs.gatherCardRef.clearSelection(); // 清空选中列表数据
      }
    },
    // 返回请求参数
    returnQueryInfo(type) {
      let detailParams = {};
      if(type == '列表') {
        detailParams = {
          type: this.userInfoMd.objtype == 6?2:1,
          sserial: this.searchGLForm.sserial, // 起始序列号
          eserial: this.searchGLForm.eserial, // 结束序列号
        };
        if(this.userInfoMd.objtype == 0 || (this.userInfoMd.objtype !=0&&this.userInfoMd.isopenfinancial)) {
          if(this.userInfoMd.objtype == 0) {
            detailParams.corderucode = this.searchGLForm.corderInfo?this.searchGLForm.corderInfo.flowcode:''; // 业务员编号
          } else {
            detailParams.corderucode = this.searchGLForm.corderInfo?(this.searchGLForm.corderInfo.pflowname?this.searchGLForm.corderInfo.pflowcode:this.searchGLForm.corderInfo.flowcode):''; // 业务员编号
          }
        } else {
          detailParams.membercode = this.searchGLForm.membercode; // 会员编号
        }
      } else{
        detailParams = {
          type: this.userInfoMd.objtype == 0?1:2,
          sserial: this.searchGLForm.sserial, // 起始序列号
          eserial: this.searchGLForm.eserial, // 结束序列号
          membercode: this.formInline.membercode, // 会员编号
          salestate: this.formInline.salestate, // 销售状态
          ssubmitdate: this.formInline.shopTime.length>0?this.dateTime(this.formInline.shopTime[0]):'', // 铺券开始时间
          esubmitdate: this.formInline.shopTime.length>0?this.dateTime(this.formInline.shopTime[1]):'', // 铺券结束时间
        };
        if(this.userInfoMd.objtype == 0 || (this.userInfoMd.objtype !=0&&this.userInfoMd.isopenfinancial)) {
          if(this.userInfoMd.objtype == 0) {
            detailParams.corderucode = this.formInline.corderInfo?this.formInline.corderInfo.flowcode:''; // 业务员编号
          } else {
            detailParams.corderucode = this.formInline.corderInfo?(this.formInline.corderInfo.pflowname?this.formInline.corderInfo.pflowcode:this.formInline.corderInfo.flowcode):''; // 业务员编号
          }
        }
      }
      return detailParams;
    },
    // 获取铺券列表信息
    getCardSalesStatisticsList() {
      let listParams = this.returnQueryInfo('列表');
      listParams.pageparam = {
        pagesize: this.pageSize, //每页条数
        currentpage: this.currentPage, //当前页数
        isnewcomp: 1 //是否需要重新统计页数
      }
      this.loading = true;
      api.GET_CARDSALESSTATISTICSLIST(listParams).then(res => {
        if(res.data.status == "200") {
          this.cardShopData = [];
          if(res.data.data && res.data.data != 'null') {
            this.cardShopData = res.data.data;
          }
          this.pagebBean = res.data.pagebean;
        }
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      })
    },
    // 接收分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.getCardSalesStatisticsList();
    },
    // 检索确定事件
    querySubmit() {
      this.currentPage = 1;
      this.getCardSalesStatisticsList();
    },
    // 导出操作确认事件
    toPrinting(type,state) {
      if(this.printingShow) {
        let queryParams = this.returnQueryInfo(state);
        if(state != '列表') {
          if(this.detailBindMemberInfo) {
            queryParams.nickname = this.detailBindMemberInfo.nickname
          }
          if(this.userInfoMd.objtype == 0 || (this.userInfoMd.objtype !=0&&this.userInfoMd.isopenfinancial)) {
            queryParams.corderuname = this.formInline.corderInfo?this.formInline.corderInfo.flowname:'';
          }
        }
        if(type == 1) {
          if(state == '列表') {
            if(this.multipleSelection&&this.multipleSelection.length>0) {
              queryParams.exceltype = 1;
              let alltotales = '';
              this.multipleSelection.forEach(item => {
                if(alltotales!=='') {
                  alltotales = alltotales + ',' + item.flowcode;
                } else {
                  alltotales = item.flowcode;
                }
              })
              this.loading = true;
              this.printingShow = false;
              queryParams.alltotale = alltotales;
              this.getUrlForCardSalesStatisticsList(queryParams);
            } else {
              this.$message({
                type: 'warning',
                message: '请至少勾选一项！'
              })
            }
          } else{
            if(this.multipleSelectiondg&&this.multipleSelectiondg.length>0) {
              queryParams.exceltype = 1;
              let alltotales = '';
              this.multipleSelectiondg.forEach(item => {
                if(alltotales!=='') {
                  alltotales = alltotales + ',' + item.code;
                } else {
                  alltotales = item.code;
                }
              })
              this.loading = true;
              this.printingShow = false;
              queryParams.alltotale = alltotales;
              this.getUrlForCardSalesStatisticsDetail(queryParams);
            } else {
              this.$message({
                type: 'warning',
                message: '请至少勾选一项！'
              })
            }
          }
        } else {
            this.loading = true;
            this.printingShow = false;
            queryParams.exceltype = 0;
            if(state == '列表') {
              this.getUrlForCardSalesStatisticsList(queryParams);
            } else {
              this.getUrlForCardSalesStatisticsDetail(queryParams);
            }
        }
      }
    },
    // 外层列表导出下载
    getUrlForCardSalesStatisticsList(params) {
      api.GET_URLFORCARDSALESSTATISTICSLIST(params).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data.indexOf('http')!=-1) {
            window.location.href = res.data.data;
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.confirmCancel();
          } else {
            MessageBox.confirm(`${res.data.data}`, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'success'
            }).then(() => {
              this.confirmCancel();
            }).catch(() => {})
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.printingShow = true;
        this.loading = false;
      }).catch(res => {
        this.loading = false;
        this.printingShow = true;
      })
    },
    // 详情导出下载
    getUrlForCardSalesStatisticsDetail(params) {
      api.GET_URLFORCARDSALESSTATISTICSDETAIL(params).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data.indexOf('http')!=-1) {
            window.location.href = res.data.data;
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.confirmCancel();
          } else {
            MessageBox.confirm(`${res.data.data}`, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'success'
            }).then(() => {
              this.confirmCancel();
            }).catch(() => {})
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.printingShow = true;
        this.loading = false;
      }).catch(res => {
        this.loading = false;
        this.printingShow = true;
      })
    },
    // 打开铺券详情弹窗
    openGatherMore(row,type) {
      if(row != 0&&type!=undefined) {
        this.rowInfo = row;
        this.formInline.salestate = type!=-1?type:null;
        if(this.userInfoMd.objtype == 0 || (this.userInfoMd.objtype !=0&&this.userInfoMd.isopenfinancial)) {
          this.formInline.corderInfo = row; // 业务员编号
        } else {
          this.formInline.membercode = row.flowcode ; // 会员编号
          this.getMemberDetail(this.formInline.membercode);
        }
        this.getCardSalesStatisticsDetail()
        this.gatherMoreShow = true;
      } else {
        this.confirmCancel();
        this.formInline = {
          corderInfo:'',//业务员
          membercode:'',//会员分销商
          shopTime: [], //铺券时间
          salestate:'',//销售状态
        }
        this.detailPageSize = 30;
        this.detailCurrentPage = 1;
        this.gatherMoreShow = false;
        this.detailBindMemberInfo = null;
      }
    },
    // 获取会员信息
    getMemberDetail(code) {
      api.GET_MEMBERDETAIL({membercode: code}).then(res => {
        if(res.data.status == "200") {
          this.detailBindMemberInfo = res.data.data;
        }
      })
    },
    // 获取详情列表
    getCardSalesStatisticsDetail() {
      let detailParams = this.returnQueryInfo('详情');
      detailParams.pageparam = {
        pagesize: this.detailPageSize, // 每页条数
        currentpage: this.detailCurrentPage, // 当前页数
        isnewcomp: 1 // 是否需要重新统计页数
      }
      this.detailLoading = true;
      api.GET_CARDSALESSTATISTICSDETAIL(detailParams).then(res => {
        if(res.data.status == "200") {
          this.gatherCardData = [];
          if(res.data.data && res.data.data != 'null') {
            this.gatherCardData = res.data.data;
          }
          this.detailPagebBean = res.data.pagebean;
        }
        this.detailLoading = false;
      }).catch(res => {
        this.detailLoading = false;
      })
    },
    // 接收分页信息
    detailUpdatePage(size,num) {
      this.detailPageSize = size;
      this.detailCurrentPage = num;
      this.getCardSalesStatisticsDetail();
    },
    // 检索确定事件
    detailQuerySubmit() {
      this.detailCurrentPage = 1;
      this.getCardSalesStatisticsDetail();
    },
    // 接收选中的铺券日期
    shopDateReceive(info) {
      if(info&&info.length>0) {
        this.formInline.shopTime[0] = info[0];
        this.formInline.shopTime[1] = info[1];
      } else {
        this.formInline.shopTime = [];
      }
    },
    // 打开选择可选商品弹窗
    getShowChoseGoods(code) {
      this.cardCode = code;
      this.goodsChoseDialogVisible = true; //非多专区可选商品
    },
    // 关闭选择可选商品弹窗
    closeGoodsChoose() {
      this.cardCode = '';
      this.goodsChoseDialogVisible = false;
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      // console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted (){
    setTimeout(() => {
      this.getHeight();
    }, 200);
    if (
      localStorage.getItem("userInfoMd") &&
      localStorage.getItem("userInfoMd") != "null" &&
      localStorage.getItem("userInfoMd") != undefined
    ) {
      this.userInfoMd = JSON.parse(localStorage.getItem("userInfoMd"));
    }
    // 获取外层列表数据
    this.getCardSalesStatisticsList();
    
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.searchForm {padding-top:64px;}
/* .searchForm >>> .el-form-item {margin-bottom:10px;} */
.pb10 {padding-bottom:10px;}
.pdr70 {width:auto;padding-right:70px;}
/*序列号段 */
/* .serialInput >>> .el-form-item__content { width: 260px;line-height:38px; border: 1px solid #dcdfe6; border-radius: 4px;}
.serialInput >>> .el-form-item__content .el-input { width: 120px;}
.serialInput >>> .el-input__inner {border: none;height:38px;line-height: 38px;} */
.comTable >>> .el-checkbox:first-child {padding:10px 20px;}

/*铺券详情弹窗 start */
.gatherDetail>>>.el-dialog{ width: 80%; min-width:1480px; }
/*铺券详情弹窗 end */
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/CardGather.vue